//for easy
import angular from "../img/cards/platforms/angular.svg";
import aurelia from "../img/cards/platforms/aurelia.svg";
import backbone from "../img/cards/platforms/backbone.svg";
import ember from "../img/cards/platforms/ember.svg";
import jsbadge from "../img/cards/platforms/js-badge.svg";
import vue from "../img/cards/platforms/vue.svg";

//for medium
import Jack_of_clubs from "../img/cards/cards/Jack_of_clubs.svg";
import Jack_of_diamonds from "../img/cards/cards/Jack_of_diamonds.svg";
import Jack_of_hearts from "../img/cards/cards/Jack_of_hearts.svg";
import Jack_of_spades from "../img/cards/cards/Jack_of_spades.svg";
import King_of_hearts from "../img/cards/cards/King_of_hearts.svg";
import King_of_spades from "../img/cards/cards/King_of_spades.svg";
import Queen_of_clubs from "../img/cards/cards/Queen_of_clubs.svg";
import Queen_of_diamonds from "../img/cards/cards/Queen_of_diamonds.svg";
import Queen_of_hearts from "../img/cards/cards/Queen_of_hearts.svg";
import Queen_of_spades from "../img/cards/cards/Queen_of_spades.svg";

//for hard
import ar from "../img/cards/flags/ar.svg";
import au from "../img/cards/flags/au.svg";
import az from "../img/cards/flags/az.svg";
import be from "../img/cards/flags/be.svg";
import bg from "../img/cards/flags/bg.svg";
import bl from "../img/cards/flags/bl.svg";
import blr from "../img/cards/flags/blr.svg";
import br from "../img/cards/flags/br.svg";
import bv from "../img/cards/flags/bv.svg";
import cm from "../img/cards/flags/cm.svg";
import cn from "../img/cards/flags/cn.svg";
import cz from "../img/cards/flags/cz.svg";
import ee from "../img/cards/flags/ee.svg";
import fi from "../img/cards/flags/fi.svg";
import fo from "../img/cards/flags/fo.svg";
import il from "../img/cards/flags/il.svg";

export const easy = [
  {
    type: "angular",
    image: angular,
  },
  {
    type: "aurelia",
    image: aurelia,
  },
  {
    type: "backbone",
    image: backbone,
  },
  {
    type: "ember",
    image: ember,
  },
  {
    type: "jsbadge",
    image: jsbadge,
  },
  {
    type: "vue",
    image: vue,
  },
];

export const medium = [
  {
    type: "Jack_of_clubs",
    image: Jack_of_clubs,
  },
  {
    type: "Jack_of_diamonds",
    image: Jack_of_diamonds,
  },
  {
    type: "Jack_of_hearts",
    image: Jack_of_hearts,
  },
  {
    type: "Jack_of_spades",
    image: Jack_of_spades,
  },
  {
    type: "King_of_hearts",
    image: King_of_hearts,
  },
  {
    type: "King_of_spades",
    image: King_of_spades,
  },
  {
    type: "Queen_of_clubs",
    image: Queen_of_clubs,
  },
  {
    type: "Queen_of_diamonds",
    image: Queen_of_diamonds,
  },
  {
    type: "Queen_of_hearts",
    image: Queen_of_hearts,
  },
  {
    type: "Queen_of_spades",
    image: Queen_of_spades,
  },
];

export const hard = [
  {
    type: "ar",
    image: ar,
  },
  {
    type: "au",
    image: au,
  },
  {
    type: "az",
    image: az,
  },
  {
    type: "be",
    image: be,
  },
  {
    type: "bg",
    image: bg,
  },
  {
    type: "bl",
    image: bl,
  },
  {
    type: "blr",
    image: blr,
  },
  {
    type: "br",
    image: br,
  },
  {
    type: "bv",
    image: bv,
  },
  {
    type: "cm",
    image: cm,
  },
  {
    type: "cn",
    image: cn,
  },
  {
    type: "cz",
    image: cz,
  },
  {
    type: "ee",
    image: ee,
  },
  {
    type: "fi",
    image: fi,
  },
  {
    type: "fo",
    image: fo,
  },
  {
    type: "il",
    image: il,
  },
];
